// Brand Colors shared across Landing Page components
export const LANDING_COLORS = {
  primary: '#d7de3b',      // Lime/Yellow
  primaryDark: '#b8bf2e',
  dark: '#1a2d56',         // Dark Blue
  darker: '#0f1a33',
  accent: '#22c55e',       // Green
  white: '#ffffff',
};
